export default __webpack_public_path__ + "static/media/calendar_icon.f24aba3a.svg";